module.exports = __webpack_public_path__ + "static/media/WheatStage115.4ac85927.PNG";